const productSchemaId = 'vscode://schemas/vscode-product';
export { productSchemaId };
